import { DOWNLOAD_SUPPLIES } from '../../constants';

const initialState = {
  data: '',
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DOWNLOAD_SUPPLIES.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DOWNLOAD_SUPPLIES.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DOWNLOAD_SUPPLIES.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
